



























































import { Note } from '@/data/models/note.model';
import { Search, SortDirection } from '@/data/models/search.model';
import { CrudService } from '@/data/services/crud.service';
import { Component, Vue, Inject } from 'vue-property-decorator';

@Component
export default class NoteList extends Vue {
    @Inject('CrudService') crudService!: CrudService<Note>;
    rows: Note[] = [];
	loading: boolean = false;

	advancedSearch: Search = new Search('note');

	constructor() {
		super();
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	loadNote() {

		const datareq = this.crudService.searchEntities(
			Note,
			'note',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			Note,
			'note',
			this.advancedSearch
		);
		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	editNote(item: Note) {
		this.$emit('edit', item);
	}
    
	deleteNote(item: Note) {
		this.$emit('delete', item);
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadNote();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadNote();
	}

}
